import * as tslib_1 from "tslib";
import { initMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import ForwardingOption from 'owa-forwarding-option/lib/ForwardingOption';
import { trace } from 'owa-trace';
var forwardingSubCategory = {
    key: 'forwarding',
    titleStringKey: 'optionTitle_forwarding',
    options: [ForwardingOption],
    onSelected: function () {
        return loadForwardingConfiguration();
    },
};
function loadForwardingConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, initMailboxForwardingConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export default forwardingSubCategory;
//# sourceMappingURL=forwardingSubCategory.js.map